import { IBallotSubmission, IQuestionSubmission, IQuestionSubmissionMap } from "../../../domain/ballot-submission";
import { IBallotState, IQuestionState } from "../../../domain/ballot-state";

export const prepareBallotSubmission = (pageState: IBallotState, voting_payload_cache_id: string | undefined | null): IBallotSubmission => {
    const question_responses: IQuestionSubmissionMap = {};
    for (const question_state of Object.values(pageState.question_states)) {
        question_responses[question_state.question_id] = prepareQuestionSubmission(question_state)
    }
    return {
        ballot_id: pageState.ballot_id,
        question_responses,
        opt_in: pageState.opt_in,
        proxy_votes: pageState.proxy_votes,
        voting_payload_cache_id: voting_payload_cache_id
    }
}


export const prepareQuestionSubmission = (question_state: IQuestionState): IQuestionSubmission => {
    return {
        question_id: question_state.question_id,
        response_type: question_state.response_type,
        value: question_state.value,
        data_version: question_state.data_version
    }
}